import React from "react";
import "./Projects.css";
import { FaReact, FaHardHat } from "react-icons/fa";
import {
  SiBlockchaindotcom,
  SiHtml5,
  SiMaterialui,
  SiChai,
  SiEthereum,
  SiExpress,
  SiSocketdotio,
  SiTailwindcss,
  SiReactrouter,
  SiJavascript,
  SiMongodb,
  SiNodedotjs,
} from "react-icons/si";
import { DiCss3 } from "react-icons/di";
import { VscJson } from "react-icons/vsc";
import { IoLogoJavascript } from "react-icons/io";
export const Projects = () => {
  return (
    <>
      <div className="section">
        <h2 className="section__title different" data-aos="fade-right">
          Projects
        </h2>
        <div className="projects_container">
          <div className="project">
            <div className="project_videocontainer">
              <div data-aos="fade-right">
                <img
                  src="https://github.com/birendra20/images/blob/main/landingpage.png?raw=true"
                  alt="Mail Chimp"
                />
              </div>
            </div>
            <div className="project_information" data-aos="fade-right">
              <h2>D-Mart Clone</h2>
              <p>
                E-Commerce website that sells Grocery Products. A collaborative
                project built by a team of 6, executed in 5 days.
              </p>
              <div>
                {/* <FaReact /> */}
                <SiHtml5 />
                <IoLogoJavascript />
                {/* <SiNodedotjs /> */}
                {/* <SiExpress />
                <SiMongodb /> */}
              </div>
              <div>
                <a
                  href="https://dmart-ready.netlify.app/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline onbt">
                    See this Live
                  </span>
                </a>
                <a
                  href="https://github.com/prathamsm7/D-Mart"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline">
                    View Code
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="projects_container">
          <div className="project">
            <div className="project_videocontainer">
              <div data-aos="fade-right">
                <img
                  src="https://github.com/birendra20/images/blob/main/Nlandingpage.png?raw=true"
                  alt=""
                />
              </div>
            </div>
            <div className="project_information" data-aos="fade-right">
              <h2>Nature's Basket</h2>
              <p>
                E-Commerce website that sells gourment foods, fruits,and grocery
                Products. A collaborative project built by a team of 6, executed
                in 5 days.
              </p>
              <div>
                <IoLogoJavascript />
                {/* <FaReact />
                <SiNodedotjs />
                <SiExpress /> */}
                {/* <SiMongodb /> */}
                <SiHtml5 />
                <DiCss3 />
              </div>
              <div>
                <a
                  href="https://naturesbasketclone.netlify.app/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline onbt">
                    See this Live
                  </span>
                </a>
                <a
                  href="https://github.com/birendra20/Nature-s-Basket-Clone"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline">
                    View Code
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="projects_container">
          <div className="project">
            <div className="project_videocontainer">
              <div data-aos="fade-right">
                <img
                  src="https://github.com/birendra20/images/blob/main/amazon-home.png?raw=true"
                  alt=""
                />
              </div>
            </div>
            <div className="project_information" data-aos="fade-right">
              <h2>Amazon-mini-App</h2>
              <p>
                E-commerce website built using React.js,functional component,
                hooks,useState ,context api,with features such as signIn,product
                page,cart page.
              </p>
              <div>
                <FaReact />

                {/* <SiMongodb /> */}
                <SiHtml5 />
                <DiCss3 />
              </div>
              <div>
                <a
                  href="https://amazon-mini-app.vercel.app/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline onbt">
                    URL for the API
                  </span>
                </a>
                <a
                  href="https://github.com/birendra20/amazon-mini-app"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline">
                    View Code
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="projects_container">
          <div className="project">
            <div className="project_videocontainer">
              <div data-aos="fade-right">
                <img
                  src="https://github.com/birendra20/images/blob/main/tic-tac-toe.png?raw=true"
                  alt="TicTacToe"
                />
              </div>
            </div>
            <div className="project_information" data-aos="fade-right">
              <h2>Classic TicTacToe</h2>
              <p>
                Mini project of A classic TicTacToe game built using ReactJS.
                Features : Button for Resetting The Game, etc.
              </p>
              <div>
                <FaReact />
                <SiHtml5 />
                <DiCss3 />
              </div>
              <div>
                <a
                  href="https://tic-tac-toe-ochre-two.vercel.app/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline onbt">
                    See this Live
                  </span>
                </a>
                <a
                  href="https://github.com/birendra20/Tic-Tac-Toe"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline">
                    View Code
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="projects_container">
          <div className="project">
            <div className="project_videocontainer">
              <div data-aos="fade-right">
                <img
                  src="https://github.com/birendra20/images/blob/main/bmi-calculator.png?raw=true"
                  alt="TicTacToe"
                />
              </div>
            </div>
            <div className="project_information" data-aos="fade-right">
              <h2>BMI-Calculator</h2>
              <p>
                Mini project of A Body-Mass-index calculator built using
                ReactJS.It helps to check wether if your are Healthy weight or
                under-Weight or obese.
              </p>
              <div>
                <SiHtml5 />
                <DiCss3 />
                <IoLogoJavascript />
              </div>
              <div>
                <a
                  href="https://bmi-calculator-psi.vercel.app/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline onbt">
                    See this Live
                  </span>
                </a>
                <a
                  href="https://github.com/birendra20/bmi-calculator"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline">
                    View Code
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
